/**
 * DataStore存取数据使用的Key值
 */


// 购物车数据
export const CART_DATA_KEY = 'MG_COMMERCE_CART';

// 用户信息
export const USER_INFO = 'MG_HW_USER_INFO';

